module.exports = __webpack_public_path__ + "img/Soc2-Badge.543cb720.png";